var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 18.5,
    height: 17.7,
    viewBox: "0 0 18.5 17.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.1,15.6c-1.1,1.2-1.7,1.2-2.7,1.2c-1.1,0-2.7-0.5-4.4-1.7C8.4,14,7.6,13.4,6,11.8c-1.7-1.7-2.8-3.1-4-5.2 C0.6,4.4,0.8,3.5,1,2.7C1.1,2,2.9,0.8,3.4,0.8c0.4,0,0.8,0.2,1.2,0.6l0.1,0.1C6,3.1,7,4.4,6.2,5.5C5.7,6.2,5.4,6.7,5.4,7.2 s1,1.6,1,1.6c0.8,0.9,2.1,2.2,3.1,3c0,0,0.9,0.6,1.4,0.6s1-0.3,2-0.9c0.1-0.1,0.2-0.1,0.4-0.1c1.1,0,3.1,1.2,3.8,1.9 C17.7,14,18,14.4,17.1,15.6 M17.7,12.8c-0.8-0.7-2.9-2.2-4.4-2.2c-0.3,0-0.6,0.1-0.9,0.2c-0.7,0.4-1.3,0.8-1.5,0.8 C10,11.5,6.2,7.8,6.3,7.1c0-0.2,0.2-0.5,0.6-1.1C7.5,5.2,7.5,4.3,7,3.3C6.5,2.4,5.9,1.7,5.3,1L5.2,0.9C4.7,0.3,4.1,0,3.4,0 S0.5,1.4,0.2,2.4C-0.1,3.3-0.3,4.5,1.1,7c1.2,2.2,2.4,3.6,4.2,5.4C7,14,7.7,14.6,9.4,15.7c1.9,1.3,3.6,2,4.9,2 c1.2,0,2.1,0,3.4-1.5C19,14.5,18.5,13.6,17.7,12.8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.4bd699bda304cd4f1ff96860a6b2b199.svg";
export { ForwardRef as ReactComponent };